// Обновление установленного приложения.
//
// Как это работает без вмешательства: браузер при запуске замечает новую версию,
// скачивает её и делает действующей — но страница, которая уже открыта, продолжает
// показывать старую. Новая появится только со следующего запуска. Человек об этом
// не знает и решает, что обновление не пришло.
//
// Поэтому: замечаем обновление сами. Если приложение только что открыли — перезагружаем
// молча, терять нечего. Если человек уже работает — показываем кнопку и ждём: посреди
// заполнения визита перезагрузка стоила бы ему всей формы.

const QUIET_RELOAD_MS = 8000;
const CHECK_EVERY_MS = 30 * 60_000;

let started = 0;
let reloading = false;

export function setupUpdates(onReady: () => void) {
  if (!("serviceWorker" in navigator)) return;
  started = Date.now();

  const hadController = Boolean(navigator.serviceWorker.controller);

  const ready = () => {
    // Первая установка на чистом планшете — это не обновление, а обычный запуск.
    if (!hadController) return;
    if (Date.now() - started < QUIET_RELOAD_MS) {
      applyUpdate();
    } else {
      onReady();
    }
  };

  navigator.serviceWorker.addEventListener("controllerchange", ready);

  void navigator.serviceWorker
    .register("/sw.js", { scope: "/" })
    .then((reg) => {
      void reg.update().catch(() => {});
      window.setInterval(() => void reg.update().catch(() => {}), CHECK_EVERY_MS);

      if (reg.waiting && hadController) ready();

      reg.addEventListener("updatefound", () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.addEventListener("statechange", () => {
          if (sw.state === "installed" && navigator.serviceWorker.controller) ready();
        });
      });
    })
    .catch(() => {});
}

export function applyUpdate() {
  if (reloading) return;
  reloading = true;
  location.reload();
}

/** Метка сборки — чтобы можно было убедиться, что обновление действительно приехало. */
export const BUILD = __APP_BUILD__;
